import {
    AfterViewInit,
    Component,
    ElementRef,
    OnChanges,
    OnInit,
    Input,
	ViewChild,
    SimpleChanges
} from '@angular/core';

import Chart from 'chart.js/auto';
import { ChartJSWidgetComponent } from '../chart-js-widget.component';

@Component({
    selector: 'app-chart-js-scatterchart',
    templateUrl: './chart-js-scatterchart.component.html',
    styleUrls: ['./chart-js-scatterchart.component.scss'],
})
export class ChartJSScatterchartComponent
    extends ChartJSWidgetComponent
    implements OnInit, OnChanges, AfterViewInit
{
    @Input() data: any;
    canvas: any;
    context: any;

    @ViewChild('chartCanvas') chartCanvas: ElementRef | null | undefined;

    chart: any;

    ngOnChanges(changes : SimpleChanges) {
        console.debug("Scatter chart : onChanges ----Start----");
        console.debug(this.canvas);
        console.debug(this.data);
        console.debug("Scatter chart : onChanges ----End----"); 
        if(changes["data"])
        {
            //this.createChart();
        }
    }

    ngOnInit(): void {
        console.debug("Scatter chart : OnInit  ----Start----");
        console.debug(this.canvas);
        console.debug(this.data);
        console.debug("Scatter chart : OnInit  ----End----");       
    }

    ngAfterViewInit(): void {
        console.debug("Scatter chart : After View Init ----Start----");
        console.debug(this.canvas);
        console.debug(this.data);
        console.debug("Scatter chart : After View Init ----End----");       
        this.createChart();
    }

    override createChart(): void {      
        console.debug("Scatter chart : Create chart ----Start----");
        console.debug(this.canvas);
        console.debug(this.data);
        console.debug("Scatter chart : Create chart ----End----");
        this.chart = new Chart(this.chartCanvas?.nativeElement, {
            type: 'bubble',
            data: this.data,
            options : { responsive : true }
        });


        // const chartData = {
        //     labels:["2015", "2016", "test"],
        //     datasets:[
        //         {
        //             label: "Data1",
        //             fill: false,
        //             lineTension: 0.1,
        //             borderColor: "transparent",
        //             backgroundColor: "rgb(255, 0, 0)",
        //             pointHoverBackgroundColor: "yellow",
        //             data: [ { x : "2015", y : 5}, {x:"test",y:10}]
        //         },
        //         {
        //             label: "Data2",
        //             fill: false,
        //             lineTension: 0.1,
        //             borderColor: "transparent", 
        //             backgroundColor: "rgb(0, 255, 0)",
        //             spanGaps: true,                   
        //             pointHoverBackgroundColor: "yellow",
        //             data: [
        //                 {x:"2015",y:5},
        //                 {x:"2016",y:10}
        //             ]                    
        //         },
        //         {
        //             label: "Data3",
        //             fill: false,
        //             lineTension: 0.1,
        //             borderColor: "transparent",
        //             backgroundColor: "rgb(0, 0, 255)",            
        //             pointHoverBackgroundColor: "yellow",
        //             data: [
        //               {x:"2015",y:3},
        //               {x:"2016",y:7},
        //               {x:"test",y:8}
        //             ]
        //           }               
        //     ]
        // };       

        // this.chart = new Chart(this.chartCanvas?.nativeElement,  { type: 'line', data: chartData});      


    }
}
